/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
// Function to apply target="_blank" to external links
function setExternalLinksNewTab() {
    var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
        // Check if the link's hostname is different from the current page's hostname
        if (links[i].hostname !== window.location.hostname) {
            links[i].target = '_blank';
            links[i].rel = 'noreferrer noopener'; // Important for security
        }
    }
}

// 1. Run when the basic HTML/DOM structure is loaded
document.addEventListener('DOMContentLoaded', setExternalLinksNewTab);

// 2. Add an additional check for dynamically loaded content (optional, but good)
window.addEventListener('load', setExternalLinksNewTab); 

// Keep your original IIFE wrapper if your theme uses it, but place the above code inside:
(function() {
    // ... paste the two event listeners and the function above here ...
})();




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
